import React from 'react';
import { Box } from '@mui/material';

interface VideoDisplayProps {
  url?: string;
  sx?: object;
}

export const VideoDisplay: React.FC<VideoDisplayProps> = ({ url, sx }) => {
  console.log('📹 VideoDisplay - Received URL:', url);

  if (!url) {
    console.log('📹 VideoDisplay - No URL provided, not rendering');
    return null;
  }

  // Extrai o ID do vídeo do YouTube da URL
  const getYoutubeVideoId = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = match && match[2].length === 11 ? match[2] : null;
    console.log('📹 VideoDisplay - Extracted video ID:', videoId);
    return videoId;
  };

  const videoId = getYoutubeVideoId(url);

  if (!videoId) {
    console.log('📹 VideoDisplay - Invalid YouTube URL');
    return null;
  }

  console.log('📹 VideoDisplay - Rendering video with ID:', videoId);

  return (
    <Box sx={{ 
      backgroundColor: 'background.paper',
      borderRadius: 1,
      boxShadow: 3,
      p: 2,
      ...sx,
      '&:hover': {
        transform: 'scale(1.02)',
        transition: 'transform 0.2s'
      }
    }}>
      <Box sx={{ 
        position: 'relative',
        paddingTop: '56.25%', // 16:9 Aspect Ratio
        width: '100%'
      }}>
        <iframe
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0
          }}
          src={`https://www.youtube.com/embed/${videoId}`}
          title="Video explicativo"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Box>
    </Box>
  );
}; 